import React from 'react';
import TextField from '@mui/material/TextField';
import '../../App.css';
import { connect } from 'react-redux';
import setDateFromAction from '../../redux/actions/createReferenceActions/actionDateFrom';
import setDateToAction from '../../redux/actions/createReferenceActions/actionDateTo';
import { withTranslation } from 'react-i18next';

function today() {

    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }

    today = yyyy + '-' + mm + '-' + dd;
    return today;
}


class DatePickers extends React.Component {

    constructor(props) {
        super(props);
        if (this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
            let dateFrom = this.props.selectedReferenceData.date_from.substr(0, 10)
            let dateTo = this.props.selectedReferenceData.date_to.substr(0, 10)
            this.state = { dateFrom: dateFrom, dateTo: dateTo };
            this.props.setDateFromFunction(this.state.dateFrom)
            this.props.setDateToFunction(this.state.dateTo)
        } else {

            this.state = { dateFrom: today(), dateTo: today() };
            this.props.setDateFromFunction(this.state.dateFrom)
            this.props.setDateToFunction(this.state.dateTo)
        }

        this.handleChangeFrom = this.handleChangeFrom.bind(this);
        this.handleChangeTo = this.handleChangeTo.bind(this);

    }

    handleChangeFrom(event) {
        this.setState({ dateFrom: event.target.value }, () => {
            this.props.setDateFromFunction(this.state.dateFrom);
        });
    }

    handleChangeTo(event) {
        this.setState({ dateTo: event.target.value }, () => {
            this.props.setDateToFunction(this.state.dateTo);
        });
    }

    render() {
        const { classes } = this.props;
        const { t } = this.props;
        return (
            <div>
                <div className='datePickerFromTo'>
                    <form className={'datepickerFrom'} noValidate onChange={this.handleChangeFrom}>
                        <TextField
                            classes={classes}
                            id="dateFrom"
                            style={{ width: 300, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}
                            label={t("create_ref.date_from") + "*"}
                            type="date"
                            variant="outlined"
                            defaultValue={this.props.selectedReferenceData ? this.state.dateFrom : today()}
                            sx={{
                                "&:hover ": {
                                    borderColor: "rgb(0,191,255)"
                                },
                                '& label.Mui-focused': {
                                    color: 'white'
                                },
                                "& .Mui-focused ": {
                                    color: 'white'
                                },
                                '& .MuiOutlinedInput-root': {
                        
                                    '&:hover fieldset': {
                                        borderColor: 'rgb(0,191,255)',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'rgb(47, 79, 79)',
                                    },
                                },
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </form>

                    <form className={'datepickerTo'} noValidate onChange={this.handleChangeTo}>
                        <TextField
                            classes={classes}
                            id="dateTo"
                            style={{ width: 300, margin: 10, borderWidth: 3, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}
                            label={t("create_ref.date_to") + "*"}
                            type="date"
                            variant="outlined"
                            defaultValue={this.props.selectedReferenceData ? this.state.dateTo : today()}
                            sx={{
                                "&:hover ": {
                                    borderColor: "rgb(0,191,255)"
                                },
                                '& label.Mui-focused': {
                                    color: 'white'
                                },
                                "& .Mui-focused ": {
                                    color: 'white'
                                },
                                '& .MuiOutlinedInput-root': {
                        
                                    '&:hover fieldset': {
                                        borderColor: 'rgb(0,191,255)',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'rgb(47, 79, 79)',
                                    },
                                },
                            }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </form>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        selectedReferenceData: state.showRefState.selectedReferenceData
    }
}

// set props to redux-store
function mapDispatchToProps(dispatch) {
    return {
        setDateFromFunction: dateFrom => {
            dispatch(setDateFromAction(dateFrom));
        },
        setDateToFunction: dateTo => {
            dispatch(setDateToAction(dateTo));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)((withTranslation()(DatePickers))); 
